module.exports = __webpack_public_path__ + "/static/assets/f2457825850317e66ef2128504613c30.svg";